import { Injectable } from '@angular/core';

// ── Service ──────────────────────────────────────────────────────────────────

/**
 * Ephemeral in-memory state for returning to the audit feed dashboard from a
 * drill-down view (e.g. an entity timeline). Nothing here is persisted to
 * localStorage/sessionStorage — it only survives for the lifetime of the app.
 */
@Injectable({
  providedIn: 'root',
})
export class AuditFeedStateService {
  private returnUrl: string | null = null;
  private scrollOffset: number | null = null;

  /**
   * Captures the dashboard's return URL and results scroll offset at
   * row-click time, so drilling into a row can be reversed later.
   */
  capture(returnUrl: string, scrollOffset: number): void {
    this.returnUrl = returnUrl;
    this.scrollOffset = scrollOffset;
  }

  /**
   * Returns the captured scroll offset and clears it. One-shot: restoring
   * scroll position should only happen once per capture.
   */
  consumeScrollOffset(): number | null {
    const scrollOffset = this.scrollOffset;
    this.scrollOffset = null;
    return scrollOffset;
  }

  /**
   * Returns the captured return URL without clearing it, so multiple
   * drill-down hops can all navigate back to the same dashboard state.
   */
  getReturnUrl(): string | null {
    return this.returnUrl;
  }
}
